
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/toplists",
      function () {
        return require("private-next-pages/dining/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/toplists"])
      });
    }
  